export const fullName = ({ firstName, lastName }) => `${firstName} ${lastName}`;
